var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("label",function(){return [(_vm.label)?_c('div',{staticClass:"mb-1 ml-2 flex"},[_c('span',{staticClass:"text-sm text-blue-text",class:_vm.customClass},[_vm._v(" "+_vm._s(_vm.label)+" ")])]):_vm._e()]}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }